// core
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// portal
import { environment } from '@open-portal-env';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';
import { GamutBrandingService } from '@campfire-nx/gamut';


@Component({
  selector: 'app-partner-style',
  templateUrl: './partner-style.component.html',
  styleUrls: ['./partner-style.component.scss']
})
export class PartnerStyleComponent implements OnInit {

  public scope!: string;
  public endpoint!: string;

  constructor(
    public partnerBrandService: PartnerBrandService,
    public gamutBrandingService: GamutBrandingService
  ) { }

  ngOnInit(): void {
    this.scope = ':root'; 
    this.endpoint = environment.apiEndpoint + '/media/';
  }
}
